/**
 * The toast after a report is queued, everywhere a report is queued: it says
 * so and has a button that opens the Print Queue (Reports > Print Queue,
 * /reports/print-queue), where the report appears. Before this each screen
 * wrote its own sentence, some telling you to "Check Print Queue" with no way
 * to get there (Neil, 2026-10-06).
 */
import { useNotificationStore, type NotificationAction, type NotificationInput } from '../stores/notificationStore';

export const PRINT_QUEUE_PATH = '/reports/print-queue';

export const OPEN_PRINT_QUEUE: NotificationAction = { label: 'Open Print Queue', to: PRINT_QUEUE_PATH };

/** Long enough to reach the button. */
const QUEUED_TOAST_MS = 10_000;

export function reportQueuedToast(message: string): NotificationInput {
  return { message, type: 'success', action: OPEN_PRINT_QUEUE, duration: QUEUED_TOAST_MS };
}

/** Show the report-queued toast. For callers outside a component; inside one, `addNotification(reportQueuedToast(...))` reads the same. */
export function notifyReportQueued(message: string): string | null {
  return useNotificationStore.getState().addNotification(reportQueuedToast(message));
}
